// extracted by mini-css-extract-plugin
export default {"container":"forgot-password_container__w6-Id"};